module.exports = __webpack_public_path__ + "static/media/logo-yellow.789bce48.svg";